import axiosInstance from '../../services/axiosInstance';
import config from "../../config";
/*istanbul ignore next*/
const postComments = async (cid, vid, rid, data) => {
  try {
    const response = await axiosInstance.post(`cvacoreservices01/api/customer/${cid}/vessel/${vid}/room/${rid}/comments`, data);
    return response.data;
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};
/*istanbul ignore next*/
const getComments = async (cid, vid, rid, start, end) =>{
    try {
        const response = await axiosInstance.get(`cvacoreservices01/api/customer/${cid}/vessel/${vid}/room/${rid}/comments?startTime=${start}&endTime=${end}`);
        return response.data;
      } catch (error) {
        console.error('API call failed:', error);
        throw error;
      }
}
/*istanbul ignore next*/
const getImage = async (cid, vid, rid, time) =>{
    try {
        const response = await axiosInstance.get(`cvacoreservices01/api/customer/${cid}/vessel/${vid}/room/${rid}/comments/file?filetype=image&time=${time}`);
        return response.data;
      } catch (error) {
        console.error('API call failed:', error);
        throw error;
      }
}
/*istanbul ignore next*/
const uploadOpsFile = async (vid, payload) =>{
  try {
      const response = await axiosInstance.post(`cvacoreservices01/api/vessels/${vid}/opsFileUpload`, payload);
      return response.data;
    } catch (error) {
      console.error('API call failed:', error);
      throw error;
    }
}
const getUserContacts = async (cid, uid) =>{
  try {
      const response = await axiosInstance.get(`cvacoreservices01/api/v2/customers/${cid}/users/${uid}/contacts`);
      return response.data;
    } catch (error) {
      console.error('API call failed:', error);
      throw error;
    }
}
 
export { postComments, getComments, getImage, uploadOpsFile, getUserContacts };